<template>
  <v-bottom-sheet v-bind="$attrs" v-model="model" inset>
    <v-sheet class="pa-4 rounded-t-xl text-center">
      <div class="d-flex flex-column">
        <text-h3 v-if="!!$slots.title" class="mt-4 mb-6 primary--text">
          <slot name="title"></slot>
        </text-h3>
        <slot></slot>
        <slot name="actions"></slot>
      </div>
    </v-sheet>
  </v-bottom-sheet>
</template>

<script>
export default {
  props: {
    value: null
  },
  computed: {
    model: {
      get () {
        return this.value
      },
      set (value) {
        this.$emit('input', value)
      }
    }
  }
}
</script>
